import { useEffect } from 'react';

const ORGANIZATION_ID = 'b94e9a0c-6891-46a4-914d-23e8a1633b6e';

interface ChatBotWidgetProps {
  templateId: string;
}

const ChatBotWidget = ({ templateId }: ChatBotWidgetProps) => {
  useEffect(() => {
    const ow: Record<string, unknown> = (window as any).__ow || {};
    ow.organizationId = ORGANIZATION_ID;
    ow.template_id = templateId;
    ow.integration_name = 'manual_settings';
    ow.product_name = 'chatbot';
    (window as any).__ow = ow;

    /* eslint-disable */
    // @ts-ignore — verbatim OpenWidget/ChatBot vendor bootstrap
    (function (n: any, t: Document, c: any) {
      function i(n: any) {
        return e._h ? e._h.apply(null, n) : e._q.push(n);
      }
      var e: any = {
        _q: [],
        _h: null,
        _v: '2.0',
        on: function () {
          i(['on', c.call(arguments)]);
        },
        once: function () {
          i(['once', c.call(arguments)]);
        },
        off: function () {
          i(['off', c.call(arguments)]);
        },
        get: function () {
          if (!e._h)
            throw new Error("[OpenWidget] You can't use getters before load.");
          return i(['get', c.call(arguments)]);
        },
        call: function () {
          i(['call', c.call(arguments)]);
        },
        init: function () {
          var s = t.createElement('script');
          s.async = true;
          s.type = 'text/javascript';
          s.src = 'https://cdn.openwidget.com/openwidget.js';
          t.head.appendChild(s);
        },
      };
      if (!n.__ow.asyncInit) e.init();
      n.OpenWidget = n.OpenWidget || e;
    })(window, document, [].slice);
    /* eslint-enable */
  }, [templateId]);

  return null;
};

export default ChatBotWidget;
